import React, { FC, useEffect, useState } from "react";
import { connect } from "react-redux";
import moment from "moment";

import * as GeneralStore from "../../store/GeneralStore";
import { State } from "../../store";
import { accountApi } from "../../api/accountApi";
import { dashboardApi } from "../../api/dashboardApi";
import SofIcon from "../common/Icons";
import BarChart from "./BarChart";
import LineChart from "./LineChart";
import "./dashboard.css";

type Props = GeneralStore.GeneralState &
  typeof GeneralStore.actionCreators;

const OperatorDashboard: FC<Props> = (props: Props) => {
  const [throughputData, setThroughputData] = useState<any>();
  const [cycletimeData, setCycletimeData] = useState<any>();

  const [cycletimeMulti, setCycletimeMulti] = useState<any>();
  const [cycletimeSingle, setCycletimeSingle] = useState<any>();


  useEffect(() => {
    accountApi.validateToken();
  }, []);

  const getThroughputData = async () => {
      const data = await dashboardApi.getThroughput();
      // console.log(data,'getThroughputData')
      setThroughputData(data)
  }

  const getCycletimeData =async () => {
    const data = await dashboardApi.getCycleTime();
    // console.log(data,'getCycletimeData')
    setCycletimeData(data);

    if(data.multiParcel.length > 0) {
      // @ts-ignore
      const statusValues = [...new Set((data.multiParcel || []).flatMap(item => item.details.map((detail: any) => detail.status)))];
      const convertedData = statusValues.map(status => {
        const newData = (data.multiParcel || []).map((item:any) => {
          const detail = item.details.find((detail: any) => detail.status === status);
          return detail ? detail.value : 0;
        });
        
        return { name: status, data: newData };
      });
      
      setCycletimeMulti(convertedData)
    }

    if(data.singleParcel.length > 0) {
      // @ts-ignore
      const statusValues = [...new Set((data.singleParcel || []).flatMap(item => item.details.map((detail: any) => detail.status)))];
      const convertedData = statusValues.map(status => {
        const newData = (data.singleParcel || []).map((item:any) => {
          const detail = item.details.find((detail: any) => detail.status === status);
          return detail ? detail.value : 0;
        });
        
        return { name: status, data: newData };
      });

      setCycletimeSingle(convertedData)
    }

  }

  useEffect(() => {
    //props.setPageTitle("DASHBOARD");
    getThroughputData()
    getCycletimeData()
  }, []);



  return (
    <>
        <div className="wrapper">
            <h1 className="text-sm underline">Nomination Report</h1>
            <div className="flex flex-row justify-between">
                <span>Nomination overview for all modalities.</span>
                <span className="data-date">
                    Data as of {moment().format("MM/DD/YY")}
                </span>
            </div>
            
            <div className="flex flex-wrap justify-between">
                <div className="graph-item">
                    <h3>Ave. Marine Nominations per Month, YTD</h3>
                    <h2>{throughputData?.multiparcelToSingRatio?.average ?? 0}</h2>
                    {throughputData?.multiparcelToSingRatio?.details?.length > 0 &&
                    <LineChart 
                        averageName="Marine Nominations"
                        categories={throughputData?.multiparcelToSingRatio?.details?.map( (d:any) => d.month)}
                        data={throughputData?.multiparcelToSingRatio?.details?.map( (d:any) => d.value)}
                    />
                    }
                </div>
                <div className="graph-item">
                    <h3>Ave. Truck Nominations per Month, YTD</h3>
                    <h2>{throughputData?.averageNomination?.average ?? 0}</h2>
                    {throughputData?.averageNomination?.details?.length > 0 &&
                    <LineChart 
                        averageName="Truck Nominations"
                        categories={throughputData?.averageNomination?.details?.map( (d:any) => d.month)}
                        data={throughputData?.averageNomination?.details?.map( (d:any) => d.value)}
                    />
                    }

                </div>
                <div className="graph-item">
                    <h3>Ave. Rail Nominations per Month, YTD</h3>
                    <h2>
                    {throughputData?.averageTransferRate?.average ?? 0}
                    {/*<span>nomination/month</span>*/}
                    </h2>
                    {throughputData?.averageTransferRate?.details?.length > 0 &&
                    <LineChart 
                        averageName="Rail Nominations"
                        categories={throughputData?.averageTransferRate?.details?.map( (d:any) => d.month)}
                        data={throughputData?.averageTransferRate?.details?.map( (d:any) => d.value)}
                    />
                    }

                </div>
            </div>

         <div className="modality flex flex-row justify-between">
          <div className="label">Cycle Time for All Modalities</div>
        </div>
        <div className="bar-chart">
            <div className="chart-heading">Average Cycle Time Breakdown per Modality (Hrs) for Current Year</div>
                {cycletimeMulti?.length > 0 &&
                    <BarChart 
                        years={(cycletimeData?.multiParcel || [])?.map( (m: any) => m.year)}
                        series={cycletimeMulti}
                    />
                }
            </div>
        {/* <div className="chart-heading">Annual Average Truck Cycle Time Breakdown for Cargo Trailer (Hrs)</div>
            {cycletimeSingle?.length > 0 &&
                <BarChart 
                    years={(cycletimeData?.singleParcel || [])?.map( (m: any) => m.year)}
                    series={cycletimeSingle}
                />
            }
        </div> */}

      {/* <div
        style={{
          position: "fixed",
          bottom: "50px",
          right: "50px"
        }}
      >
        {props.versionNumber}
      </div> */}
        </div>

    </>
  );
};

export default connect(
  (state: State) => ({
    ...state.general
  }),
  {
    ...GeneralStore.actionCreators
  }
)(OperatorDashboard as any);
